"use client"
import { useCallback, useEffect, useState } from "react"
import { usePathname } from "next/navigation"
import { useWindowResize } from "@src/hooks/use-window-resize"
import TopNav from "./top-nav"
import SideNav from "./side-nav"

const Header = () => {
  const pathname = usePathname()
  const [openNav, setOpenNav] = useState(false)

  useWindowResize()

  const handlePathnameChange = useCallback(() => {
    if (openNav) {
      setOpenNav(false)
    }
  }, [openNav])

  useEffect(() => {
    handlePathnameChange()
  }, [pathname])

  return (
    <>
      <TopNav onNavOpen={() => setOpenNav(true)} />
      <SideNav onClose={() => setOpenNav(false)} open={openNav} />
    </>
  )
}

export default Header
